
<template>
  <div class="segment-list">
    <v-list>
      <template v-for="(segment, index) in segments">
        <Segment-effort-list-item :item="segment" :key="index" v-on="$listeners"/>
      </template>
    </v-list>
  </div>
</template>

<script>
import SegmentEffortListItem from '@/ux/components/segments/SegmentEffortListItem.vue';
import linq from '@/library/linq';

export default {
  name: 'segment-effort-list',
  components: { SegmentEffortListItem },
  props: {
    segmentEfforts: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    segments: [],
  }),
  watch: {
    segmentEfforts() {
      this.generateSegments();
    },
  },
  mounted() {
    this.generateSegments();
  },
  methods: {
    generateSegments() {
      const s = linq.groupBy(this.segmentEfforts, 'segment.id')
        .map((sg) => ({ segment: sg[1][0].segment, efforts: sg[1] }));
      s.sort((a, b) => a.efforts[0].start_index - b.efforts[0].start_index);
      this.segments = s;
    },
  },
};
</script>

<style lang="scss">
.segment-list {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
